import axios from 'axios';

export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    timeout: 2000,
    headers: {
        platform: 'web',
    },
});

export const setItem = (key,data) => {
    localStorage.setItem(key,data)
}

export const getItem = (key) => {
    return JSON.parse(localStorage.getItem(key))
};

export const clearSession = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('userDetail')
}


export const baseURL = process.env.REACT_APP_BASE_URL;